/**
 * Helper function to map current series to navigator series and adjust their display.
 *
 * @param series Chart series
 * @returns Navigator series
 */
export const getColumnNavigatorSeries = (series: Highcharts.SeriesColumnOptions[]) =>
  series.map(s => ({
    id: `navigator-${s.id}`,
    stacking: s.stacking,
    stack: s.stack,
    color: s.color,
    data: s.data,
    type: "column",
    groupPadding: 0.35,
    pointPadding: 0.1,
    maxPointWidth: 20,
    borderWidth: 0,
  }));
